export default {
  mounted () {
    setTimeout(() => {
      if (this.$route.query.offset || this.$route.query.offset === 'true') {
        this.goTabPosition()
      }
      this.$root.$on('router:change', this.goTabPosition)
    }, 300)
  },
  methods: {
    goTabPosition () {
      const isPcHeader = window.matchMedia('(min-width: 980px)')
      const headerHeight = isPcHeader.matches ? 72 : 50

      if (this.$refs.tab) {
        document.documentElement.scrollTop = this.$refs.tab.$el.offsetTop -
            headerHeight - 20
        setTimeout(() => {
          document.querySelector('.header').classList.remove('header-hide')
        }, 100)
      }
    }
  }
}
